module.exports = __webpack_public_path__ + "img/2keinstellungen_valid.80a0f03a.png";